export default __webpack_public_path__ + "static/media/Today.ff028130.svg";